import React from 'react';
import { unstable_styleFunctionSx } from '@mui/system';
import { styled } from '@mui/material/styles';
import { IconButton, Stack } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import useEventListener from '../hooks/useEventListener';

const Img = styled('img')(unstable_styleFunctionSx);

const Image = (props) => {
  const { allowFullScreen, title, src, sx, mt, mb, mr, ml } = props;
  const [fullScreen, setFullScreen] = React.useState(false);
  const [zoom, setZoom] = React.useState(1);
  useEventListener("keydown", (event) => event.keyCode === 27 && fullScreen && setFullScreen(false));

  const handleToggleFullScreen = () => {
    if (fullScreen) {
      setZoom(1);
    };
    setFullScreen((prevBool) => !prevBool);
  };
  const handleZoom = (offset) => {
    let newZoom = zoom + offset;
    if (newZoom <= 0.05 || newZoom >= 5) { return; }
    newZoom = parseFloat(Number(newZoom).toFixed(2));
    setZoom(newZoom);
  };

  return (
    <Stack
      sx={{
        position: 'relative',
        maxWidth: '100%',
        ...(fullScreen && {
          position: 'fixed',
          background: 'white',
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          overflow: 'auto',
          zIndex: 1301,
        })
      }}
      mt={!fullScreen && mt}
      mb={!fullScreen && mb}
      mr={!fullScreen && mr}
      ml={!fullScreen && ml}
    >
      <Img
        sx={{
            transform: `scale(${zoom}, ${zoom})`,
            transformOrigin: 'top left',
          ...sx
        }}
        title={title}
        src={src}
      />
      {allowFullScreen && (
        <Stack sx={{ position: fullScreen ? 'fixed' : 'absolute', right: fullScreen ? 16 : 0, top: 0 }}>
        <IconButton onClick={handleToggleFullScreen}>
          {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
        {fullScreen && (
          <>
            <IconButton onClick={() => handleZoom(0.1)}><ZoomInIcon /></IconButton>
            <IconButton onClick={() => handleZoom(-0.1)}><ZoomOutIcon /></IconButton>
          </>
        )}
        </Stack>
      )}
    </Stack>

  );
};

export default Image;
